// extracted by mini-css-extract-plugin
export default {"container":"DeliveryContainer_container__h38ii","navigationContainer":"DeliveryContainer_navigationContainer__l2Zgx","contentContainer":"DeliveryContainer_contentContainer__PrMjZ"};